import { PokerCard } from "../PokerCard";

export function MultiBoardsView({ multiBoardsLabels, multiBoardsRaw }) {
  const boards = multiBoardsLabels || multiBoardsRaw || [];
  if (!boards.length) return null;

  return (
    <section
      className="border-t border-white/10 px-3 py-3 bg-purple-900/10"
      data-testid="multi-boards-view"
    >
      <h4 className="text-[11px] uppercase tracking-wider font-semibold text-purple-300 mb-2">
        Multi-board ({boards.length})
      </h4>
      <div className="flex flex-col gap-1.5">
        {boards.map((board, idx) => (
          <div key={idx} className="flex items-center gap-2">
            <span className="text-[10px] text-slate-400 tabular-nums" style={{ minWidth: 50 }}>
              Board {idx + 1}
            </span>
            <div className="flex items-center gap-1">
              {(board || []).map((c, i) => (
                <PokerCard key={i} slot={c} size={32} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
